// Lotti e matricole nelle pagine di conversione (evasione ordini, resi,
// DDT acquisto -> vendita): controlli prima dell'invio e messaggi d'errore.

// Lotti che il backend assegna da solo a una riga senza scelta esplicita:
// stessa regola di ConversionLotTracker::automatic (copia solo se non c'e'
// ambiguita'). Null se la riga e' gia' stata toccata o la copia non si applica.
export function autoAllocations(row, quantityKey) {
	const quantity = parseFloat(row[quantityKey]) || 0
	if (quantity <= 0 || row.lot_selection_touched || row.lot_source !== 'origin') return null
	const residual = (row.lot_options || []).filter((o) => (parseFloat(o.residual) || 0) > 0.0001)
	const total = residual.reduce((sum, o) => sum + parseFloat(o.residual), 0)
	const toAllocation = (o, q) => ({ lot_id: o.value, lot_id_text: o.text, quantity: q })
	if (Math.abs(total - quantity) <= 0.0001) {
		return residual.map((o) => toAllocation(o, parseFloat(o.residual)))
	}
	if (residual.length === 1 && parseFloat(residual[0].residual) + 0.0001 >= quantity) {
		return [toAllocation(residual[0], quantity)]
	}
	return null
}

// Matricole che il backend copierebbe da solo senza una scelta
export function autoCoveredSerials(row, quantityKey) {
	return !!row.serials && !!autoAllocations(row, quantityKey)
}

export function missingSerials(rows, quantityKey) {
	return (rows || []).filter((row) => {
		const quantity = parseFloat(row[quantityKey]) || 0
		if (!row.serials || quantity <= 0) return false
		// senza scelta si segnala solo cio' che e' certo scoperto
		if (!row.lot_selection_touched) return !autoCoveredSerials(row, quantityKey)
		return (row.selected_lot_allocations || []).length !== quantity
	}).map((row) => row.name)
}

export function conversionPayloadRows(rows) {
	return (rows || []).map((row) => {
		const copy = Object.assign({}, row)
		// le opzioni servono solo alla pagina: inviate farebbero un payload enorme
		delete copy.lot_options
		if (!copy.lot_selection_touched) delete copy.selected_lot_allocations
		return copy
	})
}
